import { render, staticRenderFns } from "./MO.vue?vue&type=template&id=2b28a42a&scoped=true&"
import script from "./MO.vue?vue&type=script&lang=js&"
export * from "./MO.vue?vue&type=script&lang=js&"
import style0 from "./MO.vue?vue&type=style&index=0&id=2b28a42a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b28a42a",
  null
  
)

export default component.exports